export const LANGUAGE_COOKIE_NAME = 'marketplaceLanguage';

const BUNDLED_LANGUAGES = [
  { language: 'en', locale: 'en-US', label: 'EN' },
  { language: 'fi', locale: 'fi-FI', label: 'FI' },
];

export const isSupportedLanguage = language =>
  BUNDLED_LANGUAGES.some(option => option.language === language);

export const getUserLanguagePreference = currentUser =>
  currentUser?.attributes?.profile?.privateData?.language || null;

export const languageFromLocale = locale => {
  return typeof locale === 'string' ? locale.split('-')[0].toLowerCase() : 'en';
};

export const getLanguageOptions = hostedLocale => {
  const resolvedHostedLocale = hostedLocale || 'en-US';
  const hostedLanguage = languageFromLocale(resolvedHostedLocale);

  return BUNDLED_LANGUAGES.map(option =>
    option.language === hostedLanguage ? { ...option, locale: resolvedHostedLocale } : option
  );
};

export const resolveLanguage = (preferredLanguage, hostedLocale) => {
  const options = getLanguageOptions(hostedLocale);
  const hostedLanguage = languageFromLocale(hostedLocale);
  return options.some(option => option.language === preferredLanguage)
    ? preferredLanguage
    : options.some(option => option.language === hostedLanguage)
    ? hostedLanguage
    : 'en';
};

export const localeForLanguage = (language, hostedLocale) => {
  const option = getLanguageOptions(hostedLocale).find(item => item.language === language);
  return option?.locale || hostedLocale || 'en-US';
};

export const readLanguageCookie = cookieString => {
  if (typeof cookieString !== 'string') {
    return null;
  }

  const cookie = cookieString
    .split(';')
    .map(item => item.trim())
    .find(item => item.startsWith(`${LANGUAGE_COOKIE_NAME}=`));

  return cookie
    ? decodeURIComponent(
        cookie
          .split('=')
          .slice(1)
          .join('=')
      )
    : null;
};

export const storeLanguageCookie = language => {
  if (typeof document === 'undefined') {
    return;
  }

  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LANGUAGE_COOKIE_NAME}=${encodeURIComponent(
    language
  )}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
};
